import { createContext, useState } from "react";
import notifEffect from "../../assets/sound/notif.ogg";
import { BACKEND_URL } from "../../config/constant";

let respinosApp = JSON.parse(sessionStorage.getItem("respinosApp")) || {};

const audio = new Audio(notifEffect);

export const GlobalContext = createContext();
export const GlobalProvider = (props) => {
  const [state, setState] = useState({
    user: {
      _id: respinosApp._id || "",
      token: respinosApp.token || "",
      isLogin: false,
      email: "",
      name: "",
      profile: "",
      role: "",
    },
    isLoading: false,
    alert: {
      show: false,
      type: "warning",
      message: "Oops there is something wrong",
    },
    confirm: {
      show: false,
      message: "",
      callback: null,
    },
    toast: "",
  });
  const dispatch = (topic, data) => {
    switch (topic) {
      case "user":
        if (data.profile && data.profile.avatar) {
          data.profile.avatar = `${BACKEND_URL.AVATAR}/${data.profile.avatar}`;
        }
        setState((prevState) => ({
          ...prevState,
          user: { ...prevState.user, ...data },
        }));
        break;

      case "isLoading":
        setState((prevState) => ({ ...prevState, isLoading: data }));
        break;

      case "alert":
        setState((prevState) => ({
          ...prevState,
          alert: { ...prevState.alert, ...data },
        }));
        break;

      case "confirm":
        setState((prevState) => ({
          ...prevState,
          confirm: { ...prevState.confirm, ...data },
        }));
        break;

      case "toast":
        setState((prevState) => ({
          ...prevState,
          toast: data,
        }));
        if (data != "")
          audio.play().catch((e) => {
            console.log(e);
          });
        break;

      default:
        break;
    }
  };

  return (
    <GlobalContext.Provider value={[state, dispatch]}>
      {props.children}
    </GlobalContext.Provider>
  );
};
